<template>
  <div>
    <form
      ref="form"
      @submit.prevent="checkForm"
    >
      <!-- 모달 컨텐츠 -->
      <div class="modal__contents">
        <div class="modal__middlebox">
          <div class="modal__row">
            <h2 class="subtitle subtitle--modal">
              연락처 정보를 입력 해주세요
            </h2>
          </div>
          <div class="modal__row">
            <div class="formfield">
              <ul class="formfield__row">
                <li class="formfield__inputitem">
                  <label
                    class="formfield__label formfield__label--required"
                    for="name"
                  >
                    성함
                  </label>
                  <div class="formfield__inputbox formfield__inputbox--block">               
                    <input
                      id="name"
                      v-model="req.contact.name"
                      class="formfield__input"
                      type="text"
                      autocomplete="username"
                      required="required"
                    >
                    <button 
                      v-show="req.contact.name"
                      class="formfield__clear"
                      type="button"
                      @click="clearInput('name')"
                    />
                  </div>
                </li>
                <li class="formfield__inputitem">
                  <label 
                    class="formfield__label formfield__label--required"
                    for="company"
                  >
                    소속 회사명
                  </label>                
                  <div class="formfield__inputbox formfield__inputbox--block">               
                    <input 
                      id="company"
                      v-model.trim="req.contact.company"
                      class="formfield__input"
                      type="text"
                      autocomplete="organization"
                      required="required"
                    >
                    <button 
                      v-show="req.contact.company"
                      class="formfield__clear"
                      type="button"
                      @click="clearInput('company')"
                    />
                  </div>
                </li>
              </ul>
              <ul class="formfield__row">  
                <li class="formfield__inputitem">
                  <label 
                    class="formfield__label formfield__label--required"
                    for="email"
                  >
                    이메일 주소
                  </label>                
                  <div class="formfield__inputbox formfield__inputbox--block">               
                    <input 
                      id="email"
                      v-model.trim="req.contact.email"
                      class="formfield__input"
                      type="text"
                      autocomplete="email"
                      required="required"
                    >
                    <button 
                      v-show="req.contact.email"
                      class="formfield__clear"
                      type="button"
                      @click="clearInput('email')"
                    />
                  </div>
                </li>
                <li class="formfield__inputitem">
                  <label 
                    class="formfield__label formfield__label--required"
                    for="phone"
                  >
                    연락처
                  </label>
                  <div class="formfield__inputbox formfield__inputbox--block">
                    <input 
                      id="phone"
                      v-model.trim="req.contact.phone"
                      class="formfield__input"
                      type="tel"
                      autocomplete="tel-national"
                      required="required"
                    >
                    <button 
                      v-show="req.contact.phone"
                      class="formfield__clear"
                      type="button"
                      @click="clearInput('phone')"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>    
        </div>
      </div>
      <!-- 모달 푸터(bottom) -->
      <div class="modal__footer">
        <ul class="modal__buttons">    
          <li class="modal__buttonitem">
            <button
              type="submit"
              class="button button--large"
              :disabled="!req.contact.name || !req.contact.company || !req.contact.email || !req.contact.phone"
            >
              보내기
            </button>
          </li>
        </ul>
      </div>
      <!-- 모달 이전 -->
      <div class="modal__prevbutton">
        <button 
          class="button button--function"
          @click="$emit('prev-step')"
        >
          이전
        </button>
      </div> 
    </form>
  </div>
</template>
<script>
export default{
  name:'Contact',
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  emits: ['prev-step', 'submit'],
  data(){
    return {
      req: this.request,
    }
  },
  methods:{
    checkForm() {
      console.log(this.req)
      this.$emit('submit')
    },
    clearInput(target) {
      this.req.contact[target] = ''
    },
  }
}
</script>
<style lang="scss" scoped>
.modal{
  $self:&;  
  &__row{
    &:not(:first-child){
      padding-top:30px;
    }
  }
  &__buttons{
    width:160px;
    margin:0 auto;
    &:after{
      content:'';
      clear:both;
      display:inline;
    }
  }
  &__buttonitem{
    float:left;
    width:160px;
    height:50px;
  }
}
.formfield{
  $self:&;
  width:490px;
  margin:0 auto;
  &__row{
    width:100%;
    margin:0 auto;
    &:not(:first-child){
    padding-top:15px;
    }
  }
  &__inputitem{
    float:left;
    width:240px;
    text-align:left;
    &:not(:first-child){
      margin-left:10px;
    }
  }
}
</style>